export default __webpack_public_path__ + "static/media/Nunito-Light.bebe3f7d.ttf";